import AllApis from "app/Apis/apis";
import {
  ALL_OFFLINE_STORE_FAIL,
  ALL_OFFLINE_STORE_REQUEST,
  ALL_OFFLINE_STORE_SUCCESS,
  ALL_OFFLINE_STORE_COMPANY_FAIL,
  ALL_OFFLINE_STORE_COMPANY_REQUEST,
  ALL_OFFLINE_STORE_COMPANY_SUCCESS,
} from "app/utils/constants/offlineStoreConstant";

import { Axios } from "index";

export const getAllBranchList = ({ page = 1, sort = "desc", sortBy = "created_at", search_value = "", filters = {}, }) => async (dispatch) => {
  try {
    const payload = {
      filters: filters,
      searchFields: {
        string: [
          "current_data.branch_name",
          `current_data.offlinestoreId.current_data.company_name`,
          "current_data.kyc.gst.gst_no",
          "current_data.branch_address.district",
          "current_data.branch_address.taluka",
          "current_data.branch_address.state",
          "current_data.branch_address.city",
          "current_data.contact_person.primary_email",
          "current_data.contact_person.primary_mobile",
        ],
      },
    };
    if (!search_value) {
      search_value = "";
    }

    const urlParams = new URLSearchParams({
      search: search_value.trim(),
      page: page,
      sort: sort,
      sortBy: sortBy,
    });

    dispatch({ type: ALL_OFFLINE_STORE_REQUEST});
    const Branch = await Axios.post(
      `${AllApis?.offlinestore?.branch?.list}?${urlParams.toString()}`, { ...payload }
    );
    dispatch({
      type: ALL_OFFLINE_STORE_SUCCESS,
      payload: {
        data: Branch?.data?.data?.branch,
        totalPage: Branch?.data?.totalPages,
      },
    });
  } catch (error) {
    dispatch({
      type: ALL_OFFLINE_STORE_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};

export const getAllCompanyList = ({ page = 1, sort = "desc", sortBy = "created_at", search_value = "", filters = {} }) => {
  return async (dispatch) => {
    try {
      const payload = {
        searchFields: {
          string: [
            "current_data.username",
            "current_data.company_name",
            "current_data.pan.pan_no",
          ]
        }
      }
      const urlParams = new URLSearchParams({
        search: search_value.trim(),
        page: page,
        sort: sort,
        sortBy: sortBy,
      });

      dispatch({ type:ALL_OFFLINE_STORE_COMPANY_REQUEST });

      const companyList = await Axios.post(`${AllApis?.offlinestore?.list}?${urlParams.toString()}`, { ...payload });

      dispatch({
        type: ALL_OFFLINE_STORE_COMPANY_SUCCESS, payload: {
          data: companyList?.data?.data?.offlinestore,
          totalPage: companyList?.data?.totalPages
        }
      })

    } catch (error) {
      dispatch({ type: ALL_OFFLINE_STORE_COMPANY_FAIL, payload: error?.response?.data?.message })
    }
  }
}
